// Square cover-crop to the detected bottle box — mirrors the client's
// WineMediaStrip.cropTileStyle so the ADMIN review UIs show the same crop users
// see (cropBox + the image's natural width/height). Returns null when there's no
// usable box (caller should render the image normally).
//
//   const crop = cropTileStyle(attachment, 64);
//   crop
//     ? <img src={`${url}?w=${crop.srcW}`} style={crop.style} />
//     : <img src={`${url}?w=128&h=128`} className="w-full h-full object-cover" />
// The tile element must be `position: relative; overflow: hidden`.
export function cropTileStyle(att, tile) {
  const box = att && att.cropBox;
  const W = att && att.width;
  const H = att && att.height;
  if (!box || !W || !H || !(box.w > 0) || !(box.h > 0)) return null;
  if (box.w >= 0.999 && box.h >= 0.999) return null; // full frame = nothing to crop
  const aspect = H / W;
  const Dw = Math.max(tile / box.w, tile / (box.h * aspect)); // cover the tile
  const Dh = Dw * aspect;
  return {
    srcW: Math.ceil(Dw * 2), // 2x for crispness
    style: {
      position: 'absolute',
      width: `${Math.round(Dw)}px`,
      height: `${Math.round(Dh)}px`,
      left: `${Math.round(tile / 2 - (box.x + box.w / 2) * Dw)}px`,
      top: `${Math.round(tile / 2 - (box.y + box.h / 2) * Dh)}px`,
      maxWidth: 'none',
      objectFit: 'fill',
    },
  };
}
